var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/sns/circle_google",
    clipPath: "url(#clip0_3401_97186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 85"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.2144,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.2144,
    r: 19.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6668 20.4797C31.6668 19.6524 31.5911 18.857 31.4504 18.0933H20.2383V22.6062H26.6452C26.3692 24.0646 25.5305 25.3002 24.2696 26.1274V29.0547H28.117C30.3681 27.0236 31.6668 24.0327 31.6668 20.4797Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2383 31.8812C23.4525 31.8812 26.1473 30.8365 28.117 29.0547L24.2696 26.1274C23.2036 26.8274 21.84 27.241 20.2383 27.241C17.1376 27.241 14.5132 25.1888 13.577 22.4312H9.59973V25.4539C11.5586 29.2668 15.5846 31.8812 20.2383 31.8812Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.577 22.4312C13.3389 21.7312 13.2036 20.9834 13.2036 20.2144C13.2036 19.4455 13.3389 18.6978 13.577 17.9978V14.975H9.59973C8.79345 16.55 8.3335 18.3319 8.3335 20.2144C8.3335 22.097 8.79346 23.8789 9.59973 25.4539L13.577 22.4312Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2383 13.188C21.9861 13.188 23.5554 13.7766 24.7891 14.9327L28.2036 11.5865C26.1419 9.70391 23.4471 8.54785 20.2383 8.54785C15.5846 8.54785 11.5586 11.1622 9.59973 14.975L13.577 17.9978C14.5131 15.2402 17.1376 13.188 20.2383 13.188Z",
    fill: "#EA4335"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3401_97186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.214355)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGoogleIcon);
export default __webpack_public_path__ + "static/media/login_google_icon.f3e93d9ce9fe2a5484859015713e010d.svg";
export { ForwardRef as ReactComponent };